import {request} from "services/api/util";

class MfaService {
  async deleteAdminMFA(id) {
    const config = {
      method: "delete",
      url: `admin/mfa/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}
export default new MfaService();
